import { DebugEvent } from 'core/DebugEvent';
import { DirectionalKeyType } from 'app/data/Enums';

interface DebugKeypressEventInterface {
	keyType: DirectionalKeyType;
}

export class DebugKeypressEvent extends DebugEvent implements DebugKeypressEventInterface {
	public static eventName: string = 'KEYPRESS_EVENT';
	public keyType: DirectionalKeyType;

	constructor(parameters: DebugKeypressEventInterface) {
		super(parameters);
	}
}
